import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from "~/native-ui/Typography";
import { HStack, VStack } from '~/native-ui/native-base';

const factory = (Avatar) => {
  const CardTitle = ({ avatar, children, className, subtitle, theme, title, ...other }) => {
    return (
        <VStack>
          {title && <Heading flex={0} size="lg">{title}</Heading>}
          {children && typeof children === 'string' && <Heading size="md">{children}</Heading>}
          {subtitle && <Heading size="sm" color="muted.500">{subtitle}</Heading>}
          {children && typeof children !== 'string' && children}
        </VStack>
    );
  };

  CardTitle.propTypes = {
    avatar: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.array,
    ]),
    subtitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),
  };

  return CardTitle;
};

// DEV_NOTE: Revisit
const InjectAvatar = null
const CardTitle = factory(InjectAvatar);
export default CardTitle;
export { CardTitle };
export { factory as cardTitleFactory };
